export default [

  {
    path: '/active-dzbxbbj/index',
    name: 'index',
    component: () => import('@/views/active-dzbxbbj/index'),
    meta: {
      title: '高考直通车学霸笔记电子版_独家备考资料'
    }
  },
  {
    path: '/active-dzbxbbj/myget/:id',
    name: 'myget',
    component: () => import('@/views/active-dzbxbbj/myget'),
    meta: {
      title: '免费试读'
    }
  },
  {
    path: '/active-dzbxbbj/whole-pdf/:id',
    name: 'whole-pdf',
    component: () => import('@/views/active-dzbxbbj/whole-pdf'),
    meta: {
      title: '立即学习'
    }
  },
  {
    path: '/active-dzbxbbj/split/:id',
    name: 'split',
    component: () => import('@/views/active-dzbxbbj/split'),
    meta: {
      title: '分册阅读'
    }
  },
  {
    path: '/active-dzbxbbj/mybook',
    name: 'mybook',
    component: () => import('@/views/active-dzbxbbj/mybook'),
    meta: {
      title: '我的笔记'
    }
  },
  {
    path: '/active-dzbxbbj/pdf-plus/:id',
    name: 'pdf-plus',
    component: () => import('@/views/active-dzbxbbj/pdf-plus'),
    meta: {
      title: '我的笔记'
    }
  },
  {
    path: '/active-dzbxbbj/whole-pdf/:id',
    name: 'whole-pdf',
    component: () => import('@/views/active-dzbxbbj/whole-pdf'),
    meta: {
      title: '我的笔记'
    }
  },
  {
    path: '/active-dzbxbbj/pay/:id',
    name: 'pay',
    component: () => import('@/views/active-dzbxbbj/pay'),
    meta: {
      title: '购买确认'
    }
  },
  {
    path: '/active-dzbxbbj/bjdetail/:id',
    name: 'bjdetail',
    component: () => import('@/views/active-dzbxbbj/bjdetail'),
    meta: {
      title: '手写学霸笔记'
    }
  },
  {
    path: '/active-dzbxbbj/agreement',
    component: () => import('@/views/active-dzbxbbj/agreement'),
    name: 'Agreement',
    meta: { title: '高考直通车学霸笔记服务协议'},
  },
  {
    path: '/active-dzbxbbj/paper',
    component: () => import('@/views/active-dzbxbbj/paper'),
    name: 'Agreement',
    meta: { title: '广一模纸质版购买页'},
  }
  ,
  {
    path: '/active-dzbxbbj/paper-detail/:id',
    component: () => import('@/views/active-dzbxbbj/paper-detail'),
    name: 'Agreement',
    meta: { title: '广一模纸质版购买页'},
  }
]
